import { render, staticRenderFns } from "./members-box-item.vue?vue&type=template&id=66cec456&"
import script from "./members-box-item.vue?vue&type=script&lang=js&"
export * from "./members-box-item.vue?vue&type=script&lang=js&"
import style0 from "./members-box-item.vue?vue&type=style&index=0&id=66cec456&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports